import React from 'react';

import s from './FormSection.module.scss';

type Props = {
  children: React.ReactNode;
};

export const FormSection = ({ children }: Props) => {
  return <div className={s.formSection}>{children}</div>;
};
